var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.srcUrl,"width":"100%","height":_vm.pdfH}})
}
var staticRenderFns = []

export { render, staticRenderFns }